var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import MuiRating from '@mui/material/Rating';
import Typography from '../Typography';
import { StarFilledIcon } from '../../icons/StarFilledIcon';
/**
 *  Pigment [Rating](https://pigment.customink.com/?path=/docs/components-rating)
 */
var Rating = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var ratingCount = _a.ratingCount,
    forwardableProps = __rest(_a, ["ratingCount"]);
  var padding = designTokens.spacing[8].value;
  var icon = /*#__PURE__*/React.createElement(StarFilledIcon, {
    fontSize: "inherit"
  });
  var variant = forwardableProps.size == 'small' ? 'bodyShort1' : 'bodyLong1';
  return /*#__PURE__*/React.createElement(Typography, {
    alignItems: "center",
    display: "flex",
    gap: padding,
    variant: variant
  }, /*#__PURE__*/React.createElement(MuiRating, __assign({
    emptyIcon: icon,
    icon: icon,
    precision: 0.5,
    readOnly: true,
    ref: ref
  }, forwardableProps)), (ratingCount === null || ratingCount === void 0 ? void 0 : ratingCount.toLocaleString()) || '');
});
export default Rating;